import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
    BmCustomerBillingAccountTransactionSepaObjectComponent
} from "../../component/object-components/bm-customer-billing-account-transaction-sepa-object-component/bm-customer-billing-account-transaction-sepa-object.component";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";

@Injectable({
    providedIn: 'root'
})
export class CustomerBillingAccountTransactionSepaService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/customerBillingAccountTransactionSepas')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return BmCustomerBillingAccountTransactionSepaObjectComponent;
        }
        return null;
    }
}